import { createSelector } from '@reduxjs/toolkit';
import { AuthReduxState } from './types';

export const getAuth = (state: AuthReduxState) => state.auth;
export const getUser = (state: AuthReduxState) => getAuth(state).user;
export const getAuthTicketState = createSelector(
  getAuth,
  (state) => state.authTicketState
);
